module.exports = __webpack_public_path__ + "img/noImg.b480fffb.png";